import React from 'react';
import { Box, Text, VStack, Flex } from '@chakra-ui/react';

function TimeLimitReached() {
  return (
    <>
      <Flex justify="center" align="center" py="40px">
        <Text fontSize="18px" fontWeight="bold" color="red.400">
          00:00
        </Text>
      </Flex>

      <Flex justify="center" align="center" pb="40px">
        <VStack spacing="16px">
          <Box
            width="40px"
            height="40px"
            border="2px solid"
            borderColor="purple.600"
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text fontSize="20px" color="purple.600">
              🕐
            </Text>
          </Box>

          <Text fontSize="18px" fontWeight="bold" color="gray.700" textAlign="center">
            Tempo limite atingido
          </Text>
        </VStack>
      </Flex>
    </>
  );
}

export { TimeLimitReached };
